import moment from "moment-timezone";

export const formatDateTime = (isoString) => {
  if (!isoString) return "NA";

  // Backend timestamps are always UTC (Django TIME_ZONE=UTC), but some API
  // responses omit the timezone marker (e.g. no trailing "Z") on the string.
  // moment(isoString) alone would then assume the browser's local timezone
  // and skip conversion entirely. moment.utc() forces the correct
  // interpretation regardless of whether the marker is present.
  return moment.utc(isoString)
    .tz("Asia/Singapore")
    .format("YYYY-MM-DD HH:mm");
};
